const productionPortalHostnames = new Set(['wsplayers.com', 'www.wsplayers.com']);

const apiBaseUriByHostname: Record<string, string> = {
  'wsplayers.com': 'https://api.worldsnookerdata.com',
  'www.wsplayers.com': 'https://api.worldsnookerdata.com',
  'wst-dev.sportradar.online': 'https://api.wst-dev.sportradar.online',
  'portal.wst-dev.sportradar.online': 'https://api.wst-dev.sportradar.online',
  'wst-stg.sportradar.online': 'https://api.wst-stg.sportradar.online',
  'portal.wst-stg.sportradar.online': 'https://api.wst-stg.sportradar.online',
  'wst.sportradar.online': 'https://api.wst.sportradar.online',
  'portal.wst.sportradar.online': 'https://api.wst.sportradar.online',
  'wst-players.dev.imgarena.dev': 'https://api.wst-dev.sportradar.dev',
  'wst-players.dev.srarena.io': 'https://api.wst-dev.sportradar.dev',
  'wst-players.staging.imgarena.dev': 'https://api.wst-stg.sportradar.dev',
  'wst-players.staging.srarena.io': 'https://api.wst-stg.sportradar.dev',
  'wst-players-sandbox.staging.srarena.io': 'https://wst-sandbox.staging.srarena.io',
};

export function resolveApiBaseUri(hostname: string = window.location.hostname) {
  return apiBaseUriByHostname[hostname] ?? import.meta.env.VITE_API_BASE_URI;
}

export default function getConfig(hostname: string = window.location.hostname) {
  return {
    appEnv: productionPortalHostnames.has(hostname) ? 'production' : import.meta.env.MODE,
    apiBaseUri: resolveApiBaseUri(hostname),
  };
}
